import { AppCuesService } from 'modules/shared/AppCuesService';
class LogoutController {
    static $inject = ['AuthenticationService', 'BlipService', 'SegmentService', '$state', '$location'];
    constructor(AuthenticationService, BlipService, SegmentService, $state, $location) {
        'ngInject';
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.SegmentService = SegmentService;
        this.$state = $state;
        this.$location = $location;
        this.logout();
    }
    async logout() {
        if (!this.AuthenticationService.isAuthenticated()) {
            this.$state.go('anon.login');
        }
        this.redirectUrl = this.$location.search().redirectUrl;
        this.AuthenticationService.logout();
        await this.BlipService.close();
        AppCuesService.instance.user = undefined;
        this.SegmentService.resetAccount();
        if (this.redirectUrl) {
            this.$state.go('anon.login', { 'redirectUrl': this.redirectUrl });
        }
        else {
            this.$state.go('anon.login', { notify: false });
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
LogoutController.$inject = ['AuthenticationService', 'BlipService', 'SegmentService', '$state', '$location'];
export default LogoutController;
